import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/interLatin.css";
import "./styles/app.scss";

const clarityProjectId = "vtcpexwkic";

type ClarityFunction = ((...args: unknown[]) => void) & {
  q?: unknown[][];
};

type ClarityWindow = Window &
  typeof globalThis & {
    clarity?: ClarityFunction;
  };

let clarityBooted = false;

const initClarity = (): void => {
  if (clarityBooted || typeof document === "undefined") {
    return;
  }

  clarityBooted = true;

  const clarityWindow = window as ClarityWindow;
  const clarity =
    clarityWindow.clarity ??
    (function (...args: unknown[]) {
      (clarity.q = clarity.q || []).push(args);
    } as ClarityFunction);

  clarityWindow.clarity = clarity;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${clarityProjectId}`;

  const firstScript = document.getElementsByTagName("script")[0];

  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
    return;
  }

  const parent = document.head ?? document.body;

  if (parent) {
    parent.appendChild(script);
    return;
  }

  if (import.meta.env.DEV) {
    console.warn("Clarity failed to initialize");
  }
};

if (typeof window !== "undefined") {
  initClarity();
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
